/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { FileTimeseriesSourcesSinks } from "./FileTimeseriesSourcesSinks";
import {
  FileTimeseriesSourcesSinksFromJSON,
  FileTimeseriesSourcesSinksFromJSONTyped,
  FileTimeseriesSourcesSinksToJSON,
  FileTimeseriesSourcesSinksToJSONTyped,
} from "./FileTimeseriesSourcesSinks";
import type { TwoDWaterRaster } from "./TwoDWaterRaster";
import {
  TwoDWaterRasterFromJSON,
  TwoDWaterRasterFromJSONTyped,
  TwoDWaterRasterToJSON,
  TwoDWaterRasterToJSONTyped,
} from "./TwoDWaterRaster";
import type { Wind } from "./Wind";
import { WindFromJSON, WindFromJSONTyped, WindToJSON, WindToJSONTyped } from "./Wind";
import type { LizardRasterRain } from "./LizardRasterRain";
import {
  LizardRasterRainFromJSON,
  LizardRasterRainFromJSONTyped,
  LizardRasterRainToJSON,
  LizardRasterRainToJSONTyped,
} from "./LizardRasterRain";
import type { TimeseriesLeakageOverview } from "./TimeseriesLeakageOverview";
import {
  TimeseriesLeakageOverviewFromJSON,
  TimeseriesLeakageOverviewFromJSONTyped,
  TimeseriesLeakageOverviewToJSON,
  TimeseriesLeakageOverviewToJSONTyped,
} from "./TimeseriesLeakageOverview";
import type { WindDragCoefficient } from "./WindDragCoefficient";
import {
  WindDragCoefficientFromJSON,
  WindDragCoefficientFromJSONTyped,
  WindDragCoefficientToJSON,
  WindDragCoefficientToJSONTyped,
} from "./WindDragCoefficient";
import type { TwoDSubstanceConcentration } from "./TwoDSubstanceConcentration";
import {
  TwoDSubstanceConcentrationFromJSON,
  TwoDSubstanceConcentrationFromJSONTyped,
  TwoDSubstanceConcentrationToJSON,
  TwoDSubstanceConcentrationToJSONTyped,
} from "./TwoDSubstanceConcentration";
import type { FileStructureControl } from "./FileStructureControl";
import {
  FileStructureControlFromJSON,
  FileStructureControlFromJSONTyped,
  FileStructureControlToJSON,
  FileStructureControlToJSONTyped,
} from "./FileStructureControl";
import type { TimeseriesRainOverview } from "./TimeseriesRainOverview";
import {
  TimeseriesRainOverviewFromJSON,
  TimeseriesRainOverviewFromJSONTyped,
  TimeseriesRainOverviewToJSON,
  TimeseriesRainOverviewToJSONTyped,
} from "./TimeseriesRainOverview";
import type { Substance } from "./Substance";
import {
  SubstanceFromJSON,
  SubstanceFromJSONTyped,
  SubstanceToJSON,
  SubstanceToJSONTyped,
} from "./Substance";
import type { OneDWaterLevelFile } from "./OneDWaterLevelFile";
import {
  OneDWaterLevelFileFromJSON,
  OneDWaterLevelFileFromJSONTyped,
  OneDWaterLevelFileToJSON,
  OneDWaterLevelFileToJSONTyped,
} from "./OneDWaterLevelFile";
import type { TimeseriesSourcesSinksOverview } from "./TimeseriesSourcesSinksOverview";
import {
  TimeseriesSourcesSinksOverviewFromJSON,
  TimeseriesSourcesSinksOverviewFromJSONTyped,
  TimeseriesSourcesSinksOverviewToJSON,
  TimeseriesSourcesSinksOverviewToJSONTyped,
} from "./TimeseriesSourcesSinksOverview";
import type { InitialSavedStateOverview } from "./InitialSavedStateOverview";
import {
  InitialSavedStateOverviewFromJSON,
  InitialSavedStateOverviewFromJSONTyped,
  InitialSavedStateOverviewToJSON,
  InitialSavedStateOverviewToJSONTyped,
} from "./InitialSavedStateOverview";
import type { Breach } from "./Breach";
import { BreachFromJSON, BreachFromJSONTyped, BreachToJSON, BreachToJSONTyped } from "./Breach";
import type { GroundWaterRaster } from "./GroundWaterRaster";
import {
  GroundWaterRasterFromJSON,
  GroundWaterRasterFromJSONTyped,
  GroundWaterRasterToJSON,
  GroundWaterRasterToJSONTyped,
} from "./GroundWaterRaster";
import type { GroundWaterSubstanceConcentration } from "./GroundWaterSubstanceConcentration";
import {
  GroundWaterSubstanceConcentrationFromJSON,
  GroundWaterSubstanceConcentrationFromJSONTyped,
  GroundWaterSubstanceConcentrationToJSON,
  GroundWaterSubstanceConcentrationToJSONTyped,
} from "./GroundWaterSubstanceConcentration";
import type { LocalRain } from "./LocalRain";
import {
  LocalRainFromJSON,
  LocalRainFromJSONTyped,
  LocalRainToJSON,
  LocalRainToJSONTyped,
} from "./LocalRain";
import type { FileRasterLeakage } from "./FileRasterLeakage";
import {
  FileRasterLeakageFromJSON,
  FileRasterLeakageFromJSONTyped,
  FileRasterLeakageToJSON,
  FileRasterLeakageToJSONTyped,
} from "./FileRasterLeakage";
import type { FileTimeseriesRain } from "./FileTimeseriesRain";
import {
  FileTimeseriesRainFromJSON,
  FileTimeseriesRainFromJSONTyped,
  FileTimeseriesRainToJSON,
  FileTimeseriesRainToJSONTyped,
} from "./FileTimeseriesRain";
import type { Lateral } from "./Lateral";
import {
  LateralFromJSON,
  LateralFromJSONTyped,
  LateralToJSON,
  LateralToJSONTyped,
} from "./Lateral";
import type { TimedStructureControl } from "./TimedStructureControl";
import {
  TimedStructureControlFromJSON,
  TimedStructureControlFromJSONTyped,
  TimedStructureControlToJSON,
  TimedStructureControlToJSONTyped,
} from "./TimedStructureControl";
import type { FileRasterSourcesSinks } from "./FileRasterSourcesSinks";
import {
  FileRasterSourcesSinksFromJSON,
  FileRasterSourcesSinksFromJSONTyped,
  FileRasterSourcesSinksToJSON,
  FileRasterSourcesSinksToJSONTyped,
} from "./FileRasterSourcesSinks";
import type { RasterEdit } from "./RasterEdit";
import {
  RasterEditFromJSON,
  RasterEditFromJSONTyped,
  RasterEditToJSON,
  RasterEditToJSONTyped,
} from "./RasterEdit";
import type { FileRasterRain } from "./FileRasterRain";
import {
  FileRasterRainFromJSON,
  FileRasterRainFromJSONTyped,
  FileRasterRainToJSON,
  FileRasterRainToJSONTyped,
} from "./FileRasterRain";
import type { BulkTimeseriesRain } from "./BulkTimeseriesRain";
import {
  BulkTimeseriesRainFromJSON,
  BulkTimeseriesRainFromJSONTyped,
  BulkTimeseriesRainToJSON,
  BulkTimeseriesRainToJSONTyped,
} from "./BulkTimeseriesRain";
import type { LizardRasterSourcesSinks } from "./LizardRasterSourcesSinks";
import {
  LizardRasterSourcesSinksFromJSON,
  LizardRasterSourcesSinksFromJSONTyped,
  LizardRasterSourcesSinksToJSON,
  LizardRasterSourcesSinksToJSONTyped,
} from "./LizardRasterSourcesSinks";
import type { ObstacleEdit } from "./ObstacleEdit";
import {
  ObstacleEditFromJSON,
  ObstacleEditFromJSONTyped,
  ObstacleEditToJSON,
  ObstacleEditToJSONTyped,
} from "./ObstacleEdit";
import type { LizardTimeseriesRain } from "./LizardTimeseriesRain";
import {
  LizardTimeseriesRainFromJSON,
  LizardTimeseriesRainFromJSONTyped,
  LizardTimeseriesRainToJSON,
  LizardTimeseriesRainToJSONTyped,
} from "./LizardTimeseriesRain";
import type { FileTimeseriesLeakage } from "./FileTimeseriesLeakage";
import {
  FileTimeseriesLeakageFromJSON,
  FileTimeseriesLeakageFromJSONTyped,
  FileTimeseriesLeakageToJSON,
  FileTimeseriesLeakageToJSONTyped,
} from "./FileTimeseriesLeakage";
import type { LizardTimeseriesSourcesSinks } from "./LizardTimeseriesSourcesSinks";
import {
  LizardTimeseriesSourcesSinksFromJSON,
  LizardTimeseriesSourcesSinksFromJSONTyped,
  LizardTimeseriesSourcesSinksToJSON,
  LizardTimeseriesSourcesSinksToJSONTyped,
} from "./LizardTimeseriesSourcesSinks";
import type { FileLateral } from "./FileLateral";
import {
  FileLateralFromJSON,
  FileLateralFromJSONTyped,
  FileLateralToJSON,
  FileLateralToJSONTyped,
} from "./FileLateral";
import type { TableStructureControl } from "./TableStructureControl";
import {
  TableStructureControlFromJSON,
  TableStructureControlFromJSONTyped,
  TableStructureControlToJSON,
  TableStructureControlToJSONTyped,
} from "./TableStructureControl";
import type { OneDWaterLevelPredefined } from "./OneDWaterLevelPredefined";
import {
  OneDWaterLevelPredefinedFromJSON,
  OneDWaterLevelPredefinedFromJSONTyped,
  OneDWaterLevelPredefinedToJSON,
  OneDWaterLevelPredefinedToJSONTyped,
} from "./OneDWaterLevelPredefined";
import type { SavedStateOverview } from "./SavedStateOverview";
import {
  SavedStateOverviewFromJSON,
  SavedStateOverviewFromJSONTyped,
  SavedStateOverviewToJSON,
  SavedStateOverviewToJSONTyped,
} from "./SavedStateOverview";
import type { MemoryStructureControl } from "./MemoryStructureControl";
import {
  MemoryStructureControlFromJSON,
  MemoryStructureControlFromJSONTyped,
  MemoryStructureControlToJSON,
  MemoryStructureControlToJSONTyped,
} from "./MemoryStructureControl";
import type { OneDWaterLevel } from "./OneDWaterLevel";
import {
  OneDWaterLevelFromJSON,
  OneDWaterLevelFromJSONTyped,
  OneDWaterLevelToJSON,
  OneDWaterLevelToJSONTyped,
} from "./OneDWaterLevel";
import type { OneDSubstanceConcentration } from "./OneDSubstanceConcentration";
import {
  OneDSubstanceConcentrationFromJSON,
  OneDSubstanceConcentrationFromJSONTyped,
  OneDSubstanceConcentrationToJSON,
  OneDSubstanceConcentrationToJSONTyped,
} from "./OneDSubstanceConcentration";
import type { TwoDWaterLevel } from "./TwoDWaterLevel";
import {
  TwoDWaterLevelFromJSON,
  TwoDWaterLevelFromJSONTyped,
  TwoDWaterLevelToJSON,
  TwoDWaterLevelToJSONTyped,
} from "./TwoDWaterLevel";
import type { FileBoundaryCondition } from "./FileBoundaryCondition";
import {
  FileBoundaryConditionFromJSON,
  FileBoundaryConditionFromJSONTyped,
  FileBoundaryConditionToJSON,
  FileBoundaryConditionToJSONTyped,
} from "./FileBoundaryCondition";
import type { GroundWaterLevel } from "./GroundWaterLevel";
import {
  GroundWaterLevelFromJSON,
  GroundWaterLevelFromJSONTyped,
  GroundWaterLevelToJSON,
  GroundWaterLevelToJSONTyped,
} from "./GroundWaterLevel";

/**
 * Serialized overview of simulation events.
 *
 * Optimize query count:
 *     Every entry here is executed as a separate
 *     query. Django does not support select_related
 *     for reverse foreign-key relations.
 *
 *     However you can reduce the number of queries
 *     by using select_related in the ListSerializer
 *     of a serializer, for an example look at
 *     FileRasterRainSerializer, it reduces the
 *     query count with twice the number of instances
 *     that are returned.
 * @export
 * @interface Event
 */
export interface Event {
  /**
   *
   */
  readonly substances?: Array<Substance>;
  /**
   *
   */
  readonly lizardrasterrain?: Array<LizardRasterRain>;
  /**
   *
   */
  readonly lizardtimeseriesrain?: Array<LizardTimeseriesRain>;
  /**
   *
   */
  readonly timeseriesrain?: Array<TimeseriesRainOverview>;
  /**
   *
   */
  readonly bulktimeseriesrain?: Array<BulkTimeseriesRain>;
  /**
   *
   */
  readonly breach?: Array<Breach>;
  /**
   *
   */
  readonly lizardrastersourcessinks?: Array<LizardRasterSourcesSinks>;
  /**
   *
   */
  readonly lizardtimeseriessourcessinks?: Array<LizardTimeseriesSourcesSinks>;
  /**
   *
   */
  readonly filerastersourcessinks?: Array<FileRasterSourcesSinks>;
  /**
   *
   */
  readonly filetimeseriessourcessinks?: Array<FileTimeseriesSourcesSinks>;
  /**
   *
   */
  readonly timeseriessourcessinks?: Array<TimeseriesSourcesSinksOverview>;
  /**
   *
   */
  readonly leakage?: Array<TimeseriesLeakageOverview>;
  /**
   *
   */
  readonly filetimeseriesleakage?: Array<FileTimeseriesLeakage>;
  /**
   *
   */
  readonly filerasterleakage?: Array<FileRasterLeakage>;
  /**
   *
   */
  readonly initialTwodwaterlevel?: TwoDWaterLevel;
  /**
   *
   */
  readonly initialOnedwaterlevelpredefined?: OneDWaterLevelPredefined;
  /**
   *
   */
  readonly initialGroundwaterlevel?: GroundWaterLevel;
  /**
   *
   */
  readonly initialGroundwaterraster?: GroundWaterRaster;
  /**
   *
   */
  readonly initialOnedwaterlevel?: OneDWaterLevel;
  /**
   *
   */
  readonly initialOnedwaterlevelfile?: OneDWaterLevelFile;
  /**
   *
   */
  readonly initialTwodwaterraster?: TwoDWaterRaster;
  /**
   *
   */
  readonly initialOnedSubstanceConcentrations?: Array<OneDSubstanceConcentration>;
  /**
   *
   */
  readonly initialTwodSubstanceConcentrations?: Array<TwoDSubstanceConcentration>;
  /**
   *
   */
  readonly initialGroundwaterSubstanceConcentrations?: Array<GroundWaterSubstanceConcentration>;
  /**
   *
   */
  readonly filerasterrain?: Array<FileRasterRain>;
  /**
   *
   */
  readonly filetimeseriesrain?: Array<FileTimeseriesRain>;
  /**
   *
   */
  readonly initialSavedstate?: InitialSavedStateOverview;
  /**
   *
   */
  readonly savedstates?: Array<SavedStateOverview>;
  /**
   *
   */
  readonly laterals?: Array<Lateral>;
  /**
   *
   */
  readonly filelaterals?: Array<FileLateral>;
  /**
   *
   */
  readonly fileboundaryconditions?: FileBoundaryCondition;
  /**
   *
   */
  readonly tablestructurecontrols?: Array<TableStructureControl>;
  /**
   *
   */
  readonly memorystructurecontrols?: Array<MemoryStructureControl>;
  /**
   *
   */
  readonly timedstructurecontrols?: Array<TimedStructureControl>;
  /**
   *
   */
  readonly filestructurecontrols?: Array<FileStructureControl>;
  /**
   *
   */
  readonly rasteredits?: Array<RasterEdit>;
  /**
   *
   */
  readonly obstacleedits?: Array<ObstacleEdit>;
  /**
   *
   */
  readonly localrain?: Array<LocalRain>;
  /**
   *
   */
  readonly wind?: Array<Wind>;
  /**
   *
   */
  readonly initialWinddragcoefficient?: WindDragCoefficient;
}

/**
 * Check if a given object implements the Event interface.
 */
export function instanceOfEvent(value: object): value is Event {
  return true;
}

export function EventFromJSON(json: any): Event {
  return EventFromJSONTyped(json, false);
}

export function EventFromJSONTyped(json: any, ignoreDiscriminator: boolean): Event {
  if (json == null) {
    return json;
  }
  return {
    substances:
      json["substances"] == null
        ? undefined
        : (json["substances"] as Array<any>).map(SubstanceFromJSON),
    lizardrasterrain:
      json["lizardrasterrain"] == null
        ? undefined
        : (json["lizardrasterrain"] as Array<any>).map(LizardRasterRainFromJSON),
    lizardtimeseriesrain:
      json["lizardtimeseriesrain"] == null
        ? undefined
        : (json["lizardtimeseriesrain"] as Array<any>).map(LizardTimeseriesRainFromJSON),
    timeseriesrain:
      json["timeseriesrain"] == null
        ? undefined
        : (json["timeseriesrain"] as Array<any>).map(TimeseriesRainOverviewFromJSON),
    bulktimeseriesrain:
      json["bulktimeseriesrain"] == null
        ? undefined
        : (json["bulktimeseriesrain"] as Array<any>).map(BulkTimeseriesRainFromJSON),
    breach: json["breach"] == null ? undefined : (json["breach"] as Array<any>).map(BreachFromJSON),
    lizardrastersourcessinks:
      json["lizardrastersourcessinks"] == null
        ? undefined
        : (json["lizardrastersourcessinks"] as Array<any>).map(LizardRasterSourcesSinksFromJSON),
    lizardtimeseriessourcessinks:
      json["lizardtimeseriessourcessinks"] == null
        ? undefined
        : (json["lizardtimeseriessourcessinks"] as Array<any>).map(
            LizardTimeseriesSourcesSinksFromJSON
          ),
    filerastersourcessinks:
      json["filerastersourcessinks"] == null
        ? undefined
        : (json["filerastersourcessinks"] as Array<any>).map(FileRasterSourcesSinksFromJSON),
    filetimeseriessourcessinks:
      json["filetimeseriessourcessinks"] == null
        ? undefined
        : (json["filetimeseriessourcessinks"] as Array<any>).map(
            FileTimeseriesSourcesSinksFromJSON
          ),
    timeseriessourcessinks:
      json["timeseriessourcessinks"] == null
        ? undefined
        : (json["timeseriessourcessinks"] as Array<any>).map(
            TimeseriesSourcesSinksOverviewFromJSON
          ),
    leakage:
      json["leakage"] == null
        ? undefined
        : (json["leakage"] as Array<any>).map(TimeseriesLeakageOverviewFromJSON),
    filetimeseriesleakage:
      json["filetimeseriesleakage"] == null
        ? undefined
        : (json["filetimeseriesleakage"] as Array<any>).map(FileTimeseriesLeakageFromJSON),
    filerasterleakage:
      json["filerasterleakage"] == null
        ? undefined
        : (json["filerasterleakage"] as Array<any>).map(FileRasterLeakageFromJSON),
    initialTwodwaterlevel:
      json["initial_twodwaterlevel"] == null
        ? undefined
        : TwoDWaterLevelFromJSON(json["initial_twodwaterlevel"]),
    initialOnedwaterlevelpredefined:
      json["initial_onedwaterlevelpredefined"] == null
        ? undefined
        : OneDWaterLevelPredefinedFromJSON(json["initial_onedwaterlevelpredefined"]),
    initialGroundwaterlevel:
      json["initial_groundwaterlevel"] == null
        ? undefined
        : GroundWaterLevelFromJSON(json["initial_groundwaterlevel"]),
    initialGroundwaterraster:
      json["initial_groundwaterraster"] == null
        ? undefined
        : GroundWaterRasterFromJSON(json["initial_groundwaterraster"]),
    initialOnedwaterlevel:
      json["initial_onedwaterlevel"] == null
        ? undefined
        : OneDWaterLevelFromJSON(json["initial_onedwaterlevel"]),
    initialOnedwaterlevelfile:
      json["initial_onedwaterlevelfile"] == null
        ? undefined
        : OneDWaterLevelFileFromJSON(json["initial_onedwaterlevelfile"]),
    initialTwodwaterraster:
      json["initial_twodwaterraster"] == null
        ? undefined
        : TwoDWaterRasterFromJSON(json["initial_twodwaterraster"]),
    initialOnedSubstanceConcentrations:
      json["initial_oned_substance_concentrations"] == null
        ? undefined
        : (json["initial_oned_substance_concentrations"] as Array<any>).map(
            OneDSubstanceConcentrationFromJSON
          ),
    initialTwodSubstanceConcentrations:
      json["initial_twod_substance_concentrations"] == null
        ? undefined
        : (json["initial_twod_substance_concentrations"] as Array<any>).map(
            TwoDSubstanceConcentrationFromJSON
          ),
    initialGroundwaterSubstanceConcentrations:
      json["initial_groundwater_substance_concentrations"] == null
        ? undefined
        : (json["initial_groundwater_substance_concentrations"] as Array<any>).map(
            GroundWaterSubstanceConcentrationFromJSON
          ),
    filerasterrain:
      json["filerasterrain"] == null
        ? undefined
        : (json["filerasterrain"] as Array<any>).map(FileRasterRainFromJSON),
    filetimeseriesrain:
      json["filetimeseriesrain"] == null
        ? undefined
        : (json["filetimeseriesrain"] as Array<any>).map(FileTimeseriesRainFromJSON),
    initialSavedstate:
      json["initial_savedstate"] == null
        ? undefined
        : InitialSavedStateOverviewFromJSON(json["initial_savedstate"]),
    savedstates:
      json["savedstates"] == null
        ? undefined
        : (json["savedstates"] as Array<any>).map(SavedStateOverviewFromJSON),
    laterals:
      json["laterals"] == null ? undefined : (json["laterals"] as Array<any>).map(LateralFromJSON),
    filelaterals:
      json["filelaterals"] == null
        ? undefined
        : (json["filelaterals"] as Array<any>).map(FileLateralFromJSON),
    fileboundaryconditions:
      json["fileboundaryconditions"] == null
        ? undefined
        : FileBoundaryConditionFromJSON(json["fileboundaryconditions"]),
    tablestructurecontrols:
      json["tablestructurecontrols"] == null
        ? undefined
        : (json["tablestructurecontrols"] as Array<any>).map(TableStructureControlFromJSON),
    memorystructurecontrols:
      json["memorystructurecontrols"] == null
        ? undefined
        : (json["memorystructurecontrols"] as Array<any>).map(MemoryStructureControlFromJSON),
    timedstructurecontrols:
      json["timedstructurecontrols"] == null
        ? undefined
        : (json["timedstructurecontrols"] as Array<any>).map(TimedStructureControlFromJSON),
    filestructurecontrols:
      json["filestructurecontrols"] == null
        ? undefined
        : (json["filestructurecontrols"] as Array<any>).map(FileStructureControlFromJSON),
    rasteredits:
      json["rasteredits"] == null
        ? undefined
        : (json["rasteredits"] as Array<any>).map(RasterEditFromJSON),
    obstacleedits:
      json["obstacleedits"] == null
        ? undefined
        : (json["obstacleedits"] as Array<any>).map(ObstacleEditFromJSON),
    localrain:
      json["localrain"] == null
        ? undefined
        : (json["localrain"] as Array<any>).map(LocalRainFromJSON),
    wind: json["wind"] == null ? undefined : (json["wind"] as Array<any>).map(WindFromJSON),
    initialWinddragcoefficient:
      json["initial_winddragcoefficient"] == null
        ? undefined
        : WindDragCoefficientFromJSON(json["initial_winddragcoefficient"]),
  };
}

export function EventToJSON(json: any): Event {
  return EventToJSONTyped(json, false);
}

export function EventToJSONTyped(
  value?: Omit<
    Event,
    | "substances"
    | "lizardrasterrain"
    | "lizardtimeseriesrain"
    | "timeseriesrain"
    | "bulktimeseriesrain"
    | "breach"
    | "lizardrastersourcessinks"
    | "lizardtimeseriessourcessinks"
    | "filerastersourcessinks"
    | "filetimeseriessourcessinks"
    | "timeseriessourcessinks"
    | "leakage"
    | "filetimeseriesleakage"
    | "filerasterleakage"
    | "initialTwodwaterlevel"
    | "initialOnedwaterlevelpredefined"
    | "initialGroundwaterlevel"
    | "initialGroundwaterraster"
    | "initialOnedwaterlevel"
    | "initialOnedwaterlevelfile"
    | "initialTwodwaterraster"
    | "initialOnedSubstanceConcentrations"
    | "initialTwodSubstanceConcentrations"
    | "initialGroundwaterSubstanceConcentrations"
    | "filerasterrain"
    | "filetimeseriesrain"
    | "initialSavedstate"
    | "savedstates"
    | "laterals"
    | "filelaterals"
    | "fileboundaryconditions"
    | "tablestructurecontrols"
    | "memorystructurecontrols"
    | "timedstructurecontrols"
    | "filestructurecontrols"
    | "rasteredits"
    | "obstacleedits"
    | "localrain"
    | "wind"
    | "initialWinddragcoefficient"
  > | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {};
}
